import { Fragment, ReactElement } from "react";

import { EntityProperty, EntityPropertyTypes, RydeUiUnit } from "@ryde/shared";

import { EntityPropertiesStyled } from "./entity-properties.styled";
import { EntityPropertyArrayObject } from "./entity-property-array-object";
import { EntityPropertyObject } from "./entity-property-object";
import { EntityPropertyValue } from "./entity-property-value";

interface IEntityPropertiesProps {
  entity?: RydeUiUnit;
  data: EntityProperty[];
}

export const EntityProperties = ({
  entity,
  data,
}: IEntityPropertiesProps): ReactElement => {
  return (
    <EntityPropertiesStyled className="entityProperties">
      {data?.map(item => {
        return (
          <Fragment key={item.path}>
            {(item.type === EntityPropertyTypes.Primitive ||
              item.type === EntityPropertyTypes.ArrayPrimitive) && (
              <EntityPropertyValue entity={entity} entityProperty={item} />
            )}
            {item.type === EntityPropertyTypes.ArrayObject && (
              <EntityPropertyArrayObject
                entity={entity}
                entityProperty={item}
              />
            )}
            {item.type === EntityPropertyTypes.Object && (
              <EntityPropertyObject entity={entity} entityProperty={item} />
            )}
          </Fragment>
        );
      })}
    </EntityPropertiesStyled>
  );
};
